import React from "react";
import { makeStyles } from "@material-ui/core";
import Page from "../components/Page";
import { useParams } from "react-router-dom";
import CalendarEventContainer from "../containers/mobile-frame/CalendarEventContainer";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    [theme.breakpoints.down("xs")]: {
      paddingTop: theme.spacing(1),
    },
  },
}));

const CalendarEventPage = () => {
  const classes = useStyles();
  let { eklok } = useParams();

  return (
    <Page className={classes.root} title="CalendarEvent">
      <CalendarEventContainer eklok={eklok} />
    </Page>
  );
};

export default CalendarEventPage;
